var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNewItem18Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3.75A.75.75 0 0 1 3.75 3h3.75a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-.75.75H3.75A.75.75 0 0 1 3 7.5V3.75zM10.5 3.75A.75.75 0 0 1 11.25 3H15a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-.75.75h-3.75a.75.75 0 0 1-.75-.75V3.75zM3 10.5a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-.75.75H3.75A.75.75 0 0 1 3 14.25V10.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.125 10.875a.375.375 0 0 0-.375.375v1.125h-1.125a.375.375 0 1 0 0 .75h1.125v1.125a.375.375 0 1 0 .75 0v-1.125h1.125a.375.375 0 1 0 0-.75h-1.125v-1.125a.375.375 0 0 0-.375-.375z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNewItem18Px);
export default __webpack_public_path__ + "static/media/ico-new-item-18px.e63f98cd2a0222d26fab63c94d57a93f.svg";
export { ForwardRef as ReactComponent };